import { useState, useEffect } from 'react';
import PriceHelper from '../helpers/PriceHelper';
import ValidationMessage from '../constants/validationMessage';
import Commons from '../helpers/Commons';

const useAmountValidation = (maxAmount = null, initialValue = '') => {
    const [amount, setAmount] = useState(initialValue);
    const [amountError, setAmountError] = useState('');

    const validateAmount = () => {
        let isValid = PriceHelper.validValue(amount);
        if (!isValid && !!amount) {
            setAmountError(ValidationMessage.PRICE_FORMAT_ERROR);
        } else if (maxAmount && (Commons.removeComma(amount) > maxAmount)) {
            isValid = false;
            setAmountError(ValidationMessage.PRICE_MAX_ERROR);
        } else if (amountError) {
            setAmountError('');
        }
        return isValid;
    };

    useEffect(() => {
        if (amountError) {
            setAmountError('');
        }
    }, [amount]);

    return {
        amount,
        setAmount,
        amountError,
        validateAmount,
    };
};

export default useAmountValidation;